module.exports = __webpack_public_path__ + "static/media/ic_option_select.8da0ed30.svg";